import React, { useCallback, useState } from 'react';

import { Button, Form, Select } from 'antd';

interface IProps {
  handleChangeAccount: any;
  accountDefault: any;
  listAccounts: any;
  toggleChangeAccount: any;
}

const AccountList = ({ handleChangeAccount, accountDefault, listAccounts, toggleChangeAccount }: IProps) => {
  const [selectedAccount, setSelectedAccount] = useState<any>(accountDefault);

  const onChangeAccount = useCallback((value: string) => {
    setSelectedAccount(JSON.parse(value));
  }, []);

  const confirmChangeAccount = useCallback(() => {
    handleChangeAccount(selectedAccount);
  }, [handleChangeAccount, selectedAccount]);

  return (
    <div className='flex flex-col gap-4'>
      <Form.Item label='Selecione a conta que deseja transferir:' className='mb-0'>
        <Select
          id='account'
          value={JSON.stringify(selectedAccount)}
          onChange={onChangeAccount}
          options={
            listAccounts && !listAccounts.isFetching && listAccounts.length > 0
              ? listAccounts.map((account: any) => ({
                  value: JSON.stringify(account),
                  label: `Banco: ${account.bank_id}, Ag: ${account.agency}-${account.agency_digit}, Conta: ${account.account}-${account.account_digit}, ${account.type}`,
                  key: 'acc-' + account.id
                }))
              : []
          }
        />
      </Form.Item>

      <div className='flex flex-wrap items-center justify-end gap-2'>
        <Button type='text' onClick={toggleChangeAccount}>
          Voltar
        </Button>
        <Button type='primary' onClick={confirmChangeAccount} disabled={selectedAccount === accountDefault}>
          Alterar conta
        </Button>
      </div>
    </div>
  );
};

export default AccountList;
